import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export const FaqList = ({ items, prefix = "faq" }) => (
  <Accordion type="single" collapsible className="border-t border-slate-200" data-testid={`${prefix}-list`}>
    {items.map((f, i) => (
      <AccordionItem key={f.q} value={`item-${i}`} className="border-slate-200">
        <AccordionTrigger data-testid={`${prefix}-trigger-${i}`} className="py-6 text-left text-base md:text-lg font-semibold text-[color:var(--navy)] hover:no-underline">
          {f.q}
        </AccordionTrigger>
        <AccordionContent className="pb-6 text-base leading-relaxed text-slate-600 max-w-3xl">{f.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
